const MATERIAL_NAME = {
  "post": "文章",
  "comment": "回文內容",
  "join_group_forms": "私密社團問題回答",
  "image": "圖片",
  "video": "影音",
};

export { MATERIAL_NAME };
